var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'toggle-arrow-icon',
    {
      'toggle-arrow-icon--expanded': _vm.isExpanded
    }
  ]})}
var staticRenderFns = []

export { render, staticRenderFns }